import { BACKEND_ENDPOINT } from "../utils/Common";


export async function getCollections(accessToken) {
  const response = await fetch(BACKEND_ENDPOINT + "collecting", {
    headers: {
      'Content-Type': 'application/json', 
      'Accept': 'application/json', 
      'Authorization': `Bearer ${accessToken}`
    }
  });
  return response.json();
}

export async function getCollection(accessToken, id) {
  const response = await fetch(BACKEND_ENDPOINT + `collecting?id=${id}`, {
    headers: {
      'Content-Type': 'application/json', 
      'Accept': 'application/json', 
      'Authorization': `Bearer ${accessToken}`
    }
  });
  return response.json();
}

export async function getUpcomingCollection(accessToken) {
  const response = await fetch(BACKEND_ENDPOINT + "collecting/upcoming", {
    headers: {
      'Content-Type': 'application/json', 
      'Accept': 'application/json', 
      'Authorization': `Bearer ${accessToken}`
    }
  });
  if (!response.ok) {
    throw new Error(response.status);
  }
  if (response.status === 204) {
    return null;
  }
  return response.json();
}

export async function update(token, req) {
  if (!req) {
    return;
  }
  
  const response = await fetch(BACKEND_ENDPOINT + "collecting", {
    method: 'PUT',
    body: JSON.stringify(req),
    headers: {
      'Content-Type': 'application/json', 
      'Accept': 'application/json', 
      'Authorization': `Bearer ${token}`
    }
  });
  if (!response.ok) {
    throw new Error("There was an error on our end");
  }

  return response.json();
}

export async function create(token, req) {
  if (!req) {
    return;
  }
  
  const response = await fetch(BACKEND_ENDPOINT + "collecting", {
    method: 'POST',
    body: JSON.stringify(req),
    headers: {
      'Content-Type': 'application/json', 
      'Accept': 'application/json', 
      'Authorization': `Bearer ${token}`
    }
  });

  return response.json();
}

export async function del(token, id) {
  if (!id) {
    return;
  }
  
  const response = await fetch(BACKEND_ENDPOINT + "collecting/" + id, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });

  return response.json();
}

export async function updateStatus(token, id, status) {
  if (!id) {
    return;
  }
  
  const uri = `${BACKEND_ENDPOINT}collecting/${id}/${status}`
  const response = await fetch(uri, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json', 
      'Accept': 'application/json', 
      'Authorization': `Bearer ${token}`
    }
  });

  return response.text();
}
